import { Pipe, PipeTransform } from '@angular/core';
import { AuthTokenService } from '../auth/auth-token.service';

@Pipe({
  name: 'tokenSwap',
  standalone: true
})
export class TokenSwapPipe implements PipeTransform {
  tokenStr: string | null;
  constructor(private authTokenService: AuthTokenService) {
    this.tokenStr = authTokenService.getToken();
  }

  transform(value: string | undefined, ...args: unknown[]): string {
    if (value)
      return value.replace(/__token__/g, `&token=${this.tokenStr}`);
    return '';
  }

}
